import { ScheduleByDoctorDoctorsAction, ScheduleByDoctorDoctorsState } from "./schedule.bydoctor.doctors.types";

export const scheduleByDoctorDoctorsRequestAction = (params: { pls_id: number }): ScheduleByDoctorDoctorsAction => ({ type: 'SCHEDULE_BY_DOCTOR_DOCTORS_REQUEST', params })

export const scheduleByDoctorDoctorsSuccessAction = (doctors: ScheduleByDoctorDoctorsState['doctors']): ScheduleByDoctorDoctorsAction => ({ type: 'SCHEDULE_BY_DOCTOR_DOCTORS_SUCCESS', params: doctors })

export const scheduleByDoctorDoctorsFailureAction = (error?: any) => ({ type: 'SCHEDULE_BY_DOCTOR_DOCTORS_FAILURE' } as const)